module.exports = __webpack_public_path__ + "static/media/icon-source-direct.2c23796b.svg";